
export enum NpsStep {
    FollowUp,
    FreeAnswer,
    Final
}
